import * as Sentry from "@sentry/react";
import { FC, useEffect, useRef } from "react";
import { BUILD_DATE, BUILD_VERSION, SENTRY_DSN_KEY, SENTRY_SAMPLE_RATE } from "../config/app.config";

const SentryProfiler: FC<any> = ({ children }) => {
    const alreadyInitialized = useRef(false);

    useEffect(() => {
        if (alreadyInitialized.current) {
            return;
        }

        Sentry.init({
            dsn: SENTRY_DSN_KEY,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration(),
                // v11 defaults to one session per page load; "route" keeps the pre-v11 per-navigation
                // sessions so release-health (crash-free) numbers stay comparable across the upgrade.
                Sentry.browserSessionIntegration({ lifecycle: "route" }),
            ],
            // v11 removed `sendDefaultPii` and its unset default collects user IP, cookies and HTTP bodies.
            // This keeps the v10 behaviour (none of those were collected). Change only by explicit decision.
            dataCollection: { userInfo: false, cookies: false, httpBodies: [] },
            tracesSampleRate: Number(SENTRY_SAMPLE_RATE),
            replaysSessionSampleRate: Number(SENTRY_SAMPLE_RATE),
            // so we have replay on any error. Sentry will buffer replay data, but will send it only on error
            replaysOnErrorSampleRate: 1,
            release: `${BUILD_VERSION}, date ${BUILD_DATE}`,
            ignoreErrors: ["ResizeObserver loop limit exceeded", "ResizeObserver loop completed with undelivered notifications."],
        });

        alreadyInitialized.current = true;
    }, []);

    return children;
};

export default Sentry.withProfiler(SentryProfiler);
